import axios from "axios";

const DEFAULT_BLOG_API_BASE_URL = "https://blog.outstandly.com/ghost/api";
const BLOG_API_BASE_URL = process.env.REACT_APP_BLOG_DOMAIN || DEFAULT_BLOG_API_BASE_URL;

var api = axios.create({
    baseURL: BLOG_API_BASE_URL
});

api.interceptors.request.use((config) => {
    let conf = {
        ...config,
        headers: {
            ...config.headers,
            'Content-Type': 'application/json'
        }
    }
    return {
        ...conf,
    }
});

api.interceptors.response.use(response => {
    return {
        ...response
    }
}, (error) => {
    return Promise.reject(error)
});

export default api;
